// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutoExpandTextareaController from "./auto_expand_textarea_controller"
application.register("auto-expand-textarea", AutoExpandTextareaController)

import Bridge__AuthenticatedTabsController from "./bridge/authenticated_tabs_controller"
application.register("bridge--authenticated-tabs", Bridge__AuthenticatedTabsController)

import Bridge__CloseButtonController from "./bridge/close_button_controller"
application.register("bridge--close-button", Bridge__CloseButtonController)

import Bridge__FormController from "./bridge/form_controller"
application.register("bridge--form", Bridge__FormController)

import Bridge__HeaderActionsController from "./bridge/header_actions_controller"
application.register("bridge--header-actions", Bridge__HeaderActionsController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__NotificationTokenController from "./bridge/notification_token_controller"
application.register("bridge--notification-token", Bridge__NotificationTokenController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CloseModalController from "./close_modal_controller"
application.register("close-modal", CloseModalController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import CopySuggestionController from "./copy_suggestion_controller"
application.register("copy-suggestion", CopySuggestionController)

import CurrencyController from "./currency_controller"
application.register("currency", CurrencyController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DestroyNestedAttributesController from "./destroy_nested_attributes_controller"
application.register("destroy-nested-attributes", DestroyNestedAttributesController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormAutoSaveController from "./form_auto_save_controller"
application.register("form-auto-save", FormAutoSaveController)

import FormFieldToggleController from "./form_field_toggle_controller"
application.register("form-field-toggle", FormFieldToggleController)

import FormFileAttachmentRemoverController from "./form_file_attachment_remover_controller"
application.register("form-file-attachment-remover", FormFileAttachmentRemoverController)

import GridExpandController from "./grid_expand_controller"
application.register("grid-expand", GridExpandController)

import HubspotSyncController from "./hubspot_sync_controller"
application.register("hubspot-sync", HubspotSyncController)

import IdentityController from "./identity_controller"
application.register("identity", IdentityController)

import LocationsController from "./locations_controller"
application.register("locations", LocationsController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MetricsController from "./metrics_controller"
application.register("metrics", MetricsController)

import MissionFieldCalculatorController from "./mission_field_calculator_controller"
application.register("mission-field-calculator", MissionFieldCalculatorController)

import ModalToggleController from "./modal_toggle_controller"
application.register("modal-toggle", ModalToggleController)

import NativeActionsController from "./native_actions_controller"
application.register("native-actions", NativeActionsController)

import PasswordComplexityController from "./password_complexity_controller"
application.register("password-complexity", PasswordComplexityController)

import PaymentMethodFormController from "./payment_method_form_controller"
application.register("payment-method-form", PaymentMethodFormController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import ReactController from "./react_controller"
application.register("react", ReactController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

import ResetIosConfigController from "./reset_ios_config_controller"
application.register("reset-ios-config", ResetIosConfigController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableFieldsController from "./sortable_fields_controller"
application.register("sortable-fields", SortableFieldsController)

import SyncInputController from "./sync_input_controller"
application.register("sync-input", SyncInputController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TopicCategoriesController from "./topic_categories_controller"
application.register("topic-categories", TopicCategoriesController)

import TurboFrameRequestController from "./turbo_frame_request_controller"
application.register("turbo-frame-request", TurboFrameRequestController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import WistiaController from "./wistia_controller"
application.register("wistia", WistiaController)
